module.exports = __WEBPACK_EXTERNAL_MODULE_168__;


//////////////////
// WEBPACK FOOTER
// external "mobxReact"
// module id = 168
// module chunks = 20 21